module.exports = __webpack_public_path__ + "static/bluewhale4-4186641f23af7c31363bca3e68c3c52e.png";